<template>
    <div id="index" v-if="verifiedData">
        <div class="title" v-if="getNameInfo && getNameInfo.name">
            <div class="img">
                <img src="../images/icon_id_info@3x.png">
            </div>
            <div class="name-line">
                <span class="name">{{getNameInfo.name}}</span>
                <span class="status">已认证</span>
                <i v-if="isReameShow" class="cubeic-question" @click="handleRename"></i>
            </div>
            <div class="id">{{getNameInfo.cardid}}</div>
        </div>
        <div class="title" v-else>
            <div class="img">
                <img src="../images/icon_id_info@3x.png">
            </div>
            <div class="name-line">
                <span class="name">{{verifiedData.name}}</span>
                <span class="status">已认证</span>
                <i v-if="isReameShow" class="cubeic-question" @click="handleRename"></i>
            </div>
            <div class="id">{{verifiedData.id_no}}</div>
        </div>
        <div class="info">
            <div class="info-title" v-if="filteredArray.length>1"><div class="cont">您的身份证在滴滴平台关联了以下账号</div></div>
            <div class="group" v-for="(item, index) in filteredArray" :key="index">
                <div class="item" :class="[item.current ? 'now' :'']">
                    <span class="phone">{{item.phone}}</span>
                    <span class="itm-btn btn" :class="[item.current ? 'current' : '']" @click="unbindClick(item)">{{item.current ? '当前账号' : '解绑'}}</span>
                </div>
            </div>
        </div>
        <div class="real-name-text" v-if="isShowRealName" @click="goRenamePage">变更实名信息</div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { setPageTitle } from '@didi/public-sdk'
import { initUnVerifiedRouter, showConfirm } from '../api'
import { name_auth_omega_summary } from 'common-js/omega'
import { goClearNamePage, sendOmega } from '../config/state'
import { urlObj } from '../config/url'
import url from 'common-js/util/url'
import { defaultBiz } from '../config/utils'

export default {
  data () {
    return {
      unbindItem: {},
      type: 2,
      isReameShow: false,
      isShowRealName: false
    }
  },
  watch: {
    need_change_rn_info: {
      handler(val) {
        if (val) {
          this.realNameInfo()
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapGetters(['verifiedData', 'unVerified', 'env', 'cell', 'getNameInfo']),
    filteredArray () {
      let Arr1 = []
      let Arr2 = []
      const { accounts } = this.verifiedData
      const identity_cards = this.unVerified && this.unVerified.identity_cards
      const passengerIsRealName = identity_cards && identity_cards.some((item) => item.role === 1 && item.tag && item.tag.length === 1)
      const currentRoleIsPassenger = identity_cards && identity_cards.some((item) => item.current && item.role === 1)
      const newPassengerIsRealName = currentRoleIsPassenger && this.unVerified && !this.unVerified.has_conflict
      if (newPassengerIsRealName || passengerIsRealName) {
        identity_cards && identity_cards.forEach((item) => {
          if (item.current) {
            const obj = {
              ...item,
              phone: this.cell,
            }
            Arr1.push(obj)
          }
        })
      }
      accounts && accounts.forEach(item => {
        if (item.current === true) {
          Arr1.push(item)
        } else if (typeof accounts.current === 'undefined') {
          Arr2.push(item)
        }
      })
      let Arr = Arr1.concat(Arr2)
      return Arr
    },
    unVerifiedInfo() {
      const identity_cards = this.unVerified && this.unVerified.identity_cards
      // 找到乘客端
      const info = identity_cards && identity_cards.find((item) => item.role === 1)
      return info
    },
    need_change_rn_info() {
      return this.getNameInfo.need_change_rn_info === 'true'
    }
  },
  methods: {
    ...mapMutations([
      'CELLID'
    ]),
    unbindClick (_item) {
      const { cell_id, phone } = _item
      sendOmega(name_auth_omega_summary['Trinity_realname_remove_ck'])
      if (_item.current) {
        return
      }
      this.unbindItem = {
        cell_id,
        phone
      }
      window.GlobalSet.query.cell_id = cell_id
      this.CELLID(cell_id)
      const { id_no } = this.verifiedData
      const _this = this
      showConfirm(this, {
        content: `您是否确认要将账号${phone}与实名${id_no}解除关联`,
        confirmText: '解除关联',
        cancelText: '取消',
        onConfirm: () => {
          sendOmega(name_auth_omega_summary['pub_trinity_removepop_sure_ck'])
          // _this.$router.push({
          //   name: 'MesVerify',
          //   query: {
          //     type: _this.type
          //   }
          // })
          initUnVerifiedRouter(_this)
        },
        onCancel: () => {
          sendOmega(name_auth_omega_summary['pub_trinity_removepop_cancel_ck'])
        }
      })
    },
    handleRename () {
      goClearNamePage()
    },
    realNameInfo() {
      if ((window.Fusion && window.Fusion.getSystemInfo) || window.GlobalSet.query.appid) {
        this.isShowRealName = true
        sendOmega(name_auth_omega_summary['pub_identity_change_sw'], {
          type: 'name_auth'
        })
      }
    },
    goRenamePage() {
      sendOmega(name_auth_omega_summary['pub_identity_change_ck'], {
        type: 'name_auth'
      })
      const renameInfo = `${urlObj.goNameIdentityPage}#/rename-info?biz=${defaultBiz()}&step=card&defaultSucc=self&renameChannel=name_auth&appid=${window.GlobalSet.query.appid}&phone=${window.GlobalSet.query.phone}&from=${window.GlobalSet.from}`
      url.go(renameInfo, {}, false)
    }
  },
  mounted () {
    sendOmega(name_auth_omega_summary['trinity_rightidshow_sw'])
    setPageTitle({
      title: '统一实名认证',
    })
    this.isReameShow = false
  },
}
</script>
<style lang="scss">
@import '~common-css/mixins.scss';
body{
    width:100%;
    overflow-x: hidden;
}
.now{
    color:#FC9153
}
#index{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #F3F4F5;
    .title{
        background:linear-gradient(-166deg, #7B7F9A 0%, #626682 94%);
        .img{
            text-align:center;
            img{
                margin:px2rem(80) 0 px2rem(60) 0;
                width:px2rem(100);
            }
        }
        .name-line{
            font-size:px2rem(44);
            text-align: center;
            color:#fff;
            .name{
                vertical-align: middle;
            }
            .status{
                font-size:px2rem(16);
                vertical-align: middle;
                padding:px2rem(2) px2rem(5);
                font-weight: lighter;
                margin-left:px2rem(10);
                height:px2rem(28);
                line-height:px2rem(28);
                display:inline-block;
                @include border-1px(#fff, 2px, solid);
            }
        }
        .id{
            margin-top: px2rem(10);
            text-align: center;
            color: #fff;
            font-size:px2rem(44);
            padding-bottom: px2rem(140);
        }
    }
    .info{
        background:#fff;
        width: 94%;
        margin-left: 3%;
        margin-top: px2rem(-60);
        font-size: px2rem(32);
        border-radius: 5px;
        .info-title{
            color:#666;
            font-size:px2rem(24);
            .cont{
                padding:px2rem(20) 0 px2rem(20) px2rem(40);
            }
            &::after{
                content: '';
                // height: 1px;
                border-bottom: 1px solid #F5F5F5;
                margin-left: 6%;
                display:block;
            }
        }
        .group{
            .item{
                padding: px2rem(38) 0;
                .phone{
                    padding-left:px2rem(40);
                    vertical-align: middle;                }
                .itm-btn{
                    display:inline-block;
                    font-size:px2rem(24);
                    text-align:center;
                    vertical-align: middle;
                    float: right;
                    margin-right: 1rem;
                    width:3rem;
                }
                .btn{
                    border: 1px solid;
                    padding:px2rem(9) 0;
                    border-radius: 3px;
                    color:#666;
                }
                .current{
                    width:4rem;
                    transform: translate(0.5rem);
                }

            }
            .now{
                .phone{
                    &::after{
                        content:'';
                        background-image:url('data:image/png;base64,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');
                        display:inline-block;
                        width:px2rem(26);
                        height:px2rem(26);
                        margin-left:px2rem(14);
                        background-size: contain;
                        background-repeat:no-repeat;
                    }
                }
                .btn{
                    color:#FC9153;
                    border:none;
                }
            }

        }
    }
    footer{
        text-align: center;
        font-size: px2rem(24);
        padding: px2rem(60) 0;
        vertical-align: middle;
        color:#999;
        &::before{
            content:'';
            background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAn1JREFUSA29lctrE1EUxjuTh4YYnwtFsJv6gKKrurKlG0VcSQRB0GBMyMOVK3FX6dr/IA8SI8GFiGbhQtGCiIobV0rFhZu6UayiLQHNY+LvhLnlOp2ZjIpeuDmv73zn3pt7zxhjPqNUKo0TThqGcWIwGOxH7hI4+gf0t8gHmK1isbgkfrdhuDlrtdqeXq83D8F54mE3jObrUexGOByez2az7zX/UF1XoFwunyJSg3yrE+xnU+Qr8WyhULir40zdgPwixHcc5AumaeYgOBCLxTbJFF185C6ofMmRXOFQPpFrO6hUKqcB3GIq3zviFzjfp3qCU+d/msF3nTlhxyyKn8nn87fFHpJBvtOyrDfY22zQ63g8Pp1KpVZs21c0m83N7Xb7GaCDAmSHX5iTFPk4PCJWfQ2/Il9mBSeDkguhYCUHdVls+LbbnGOGrB5jiRmVYCgUOpbL5dbOVnxBR7VaPdrv9x8Jnh10mOMmxOcUOY7Hf0oupJIrHKILJ8d+VgpMi8MeN5XyF1LnmJFHNKuRTXHNViORSCuTyXzX/CPVer2+sdvtJgFOaeBZg2s20BxKXUQ5whX9phx+Eo4txJ8zJ524Xx6aFhTgFc0epQp2HbkkeRWQ2GH5CTg8sZ4FuA0bApLLlfTEehYISj4K918KBOo3o1bqFufoPskO5Kv0r0bJjEajl6j0wlmBFx54Z04sfKvMObrp1WG7BiBNbx/O3aoQhV+l0+nPyvaTjUZjR6fTOSQY+s8KuYuqE6iPi1/+MMZrnWAB91lMD8dl2nPbLQmMRdN7omLSi4KOJOR7bfA9VuqaR4GHBI6r4O8UaJEs32zPHbCrH4lE4qUiF/kThAPupkiTSVcAAAAASUVORK5CYII=');
            width: px2rem(24);
            height: px2rem(24);
            display: inline-block;
            background-size: contain;
            background-repeat: no-repeat;
            padding-right: px2rem(10);
            vertical-align: middle;

        }
    }
    .real-name-text {
      font-size: px2rem(24);
      color: #FF7D41;
      position: absolute;
      bottom: px2rem(70);
      padding: px2rem(20);
      width: 94%;
      text-align: center;
    }
}
</style>
